import { UploadFile } from 'antd'
import { addRoutes } from 'packages/route'
import { MenuProvider } from 'packages/web-layout/menu-utils'

import { ActivityHomeParams } from './Home/types'
import { AnnouncementTaskParams } from './UserTasks/Announcement/types'
import { UserCourseTaskParams } from './UserTasks/Course/types'
import { EnrollTaskParams } from './UserTasks/Enroll/types'
import { QuestionnaireTaskParams } from './UserTasks/Questionnaire/types'
import { QuizTaskParams } from './UserTasks/Quiz/types'
import {
  ActivityRouteModalParams,
  ActivityRouteParams,
} from './activities/types'
import { BiosourceParams } from './admissions/types'
import { GatewayModalParams, UserGatewayParams } from './gateway/types'
import { GatewayManagementParams } from './gatewayManagement/types'
import { StudentManagementParams } from './studentManagement/types'
import { AdminStudentsParams } from './students/types'
import { SystemSettingParams } from './systemSetting/types'
import { TeacherManagementParams } from './teacherManagement/types'
import { TestPaperModalParams, TestPaperParams } from './test-paper/types'

export type InitFeatureParams = {
  addRoutes: typeof addRoutes
  addMenuProvider: (p: MenuProvider) => void
  hasAnyAdminPermission?: boolean
}

export type FeatureRouteParams = AdminStudentsParams &
  BiosourceParams &
  QuestionnaireTaskParams &
  ActivityRouteParams &
  UserCourseTaskParams &
  AnnouncementTaskParams &
  EnrollTaskParams &
  ActivityHomeParams &
  TestPaperParams &
  QuizTaskParams &
  StudentManagementParams &
  TeacherManagementParams &
  GatewayManagementParams &
  UserGatewayParams &
  SystemSettingParams

export type FeatureRouteModalParams = ActivityRouteModalParams &
  TestPaperModalParams &
  GatewayModalParams

export type AttachmentFile = UploadFile & {
  url: string
  /**
   * 视频时长
   */
  duration?: string
}

export const OPEN_TASK_ID_ENCODE_KEY = 'open_task_id'
